import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './web_autotest_female_funnel_check'
import web_wheel_of_fortune_walking_female from './web_wheel_of_fortune_walking_female'
import web_wheel_of_fortune_activity_female from './web_wheel_of_fortune_activity_female'
import web_wheel_of_fortune_yoga_female from './web_wheel_of_fortune_yoga_female'
import web_wheel_of_fortune_male from './web_wheel_of_fortune_male'
import web_summary_checkpoints_walking from './web_summary_checkpoints_walking'
import web_summary_checkpoints_yoga from './web_summary_checkpoints_yoga'
import web_ai_generated_female_funnel from './web_ai_generated_female_funnel'
import web_apple_pay_renaming from './web_apple_pay_renaming'
import web_upsell_double_offering from './web_upsell_double_offering'
import web_ask_age_starting_screens from './web_ask_age_starting_screens'
import web_fallback_on_payment from './web_fallback_on_payment'
import web_en_countries_price_optimization from './web_en_countries_price_optimization'
import web_bulk_change_walking_female from './web_bulk_change_walking_female'
import web_tiers_as_upgrade_pilates from './web_tiers_as_upgrade_pilates'
import web_pricing_on_pilates_funnel_with_sp from './web_pricing_on_pilates_funnel_with_sp'
import web_yoga_printable_guide_welcome from './web_yoga_printable_guide_welcome'
import web_walking_female_weight_loss_plan from './web_walking_female_weight_loss_plan'
import web_walking_to_lose_weight_gdn from './web_walking_to_lose_weight_gdn'
import web_walking_to_lose_weight_keyword from './web_walking_to_lose_weight_keyword'
import web_pricing_on_fasting_funnels_with_sp_nonus from './web_pricing_on_fasting_funnels_with_sp_nonus'
import web_walking_female_indoor from './web_walking_female_indoor'
import web_chair_workouts_male_scratch_card from './web_chair_workouts_male_scratch_card'
import web_pricing_for_desktop from './web_pricing_for_desktop'
import web_walking_male_one_predict_instead_of_two from './web_walking_male_one_predict_instead_of_two'
import web_welcome_for_search_fasting_schedule from './web_welcome_for_search_fasting_schedule'
import web_chair_yoga_challenge_landing from './web_chair_yoga_challenge_landing'
import web_welcome_for_search_fasting_lose_weight from './web_welcome_for_search_fasting_lose_weight'
import web_fasting_fem_scratch_card_before_the_paywall from './web_fasting_fem_scratch_card_before_the_paywall'
import web_welcome_for_demgen_walking from './web_welcome_for_demgen_walking'
import web_dynamic_email_capture from './web_dynamic_email_capture'
import web_yoga_female_scratch_card_before_the_paywall from './web_yoga_female_scratch_card_before_the_paywall'
import web_all_payment_options_at_once from './web_all_payment_options_at_once'
import web_walking_loader_with_women from './web_walking_loader_with_women'
import web_pilates_gamification_progress from './web_pilates_gamification_progress'
import web_coins_in_exchange_for_discount from './web_coins_in_exchange_for_discount'
import web_fasting_fem_paywall_w_plan_benefits from './web_fasting_fem_paywall_w_plan_benefits'
import web_thai_chi_walking_fem_christmas_sale from './web_thai_chi_walking_fem_christmas_sale'
import web_tai_chi_walking_female_plan_benefits from './web_tai_chi_walking_female_plan_benefits'
import web_welcome_for_search_fasting_diet_keywords from './web_welcome_for_search_fasting_diet_keywords'
import web_chair_workouts_male_subtitles from './web_chair_workouts_male_subtitles'
import web_welcome_for_search_fasting_calculator from './web_welcome_for_search_fasting_calculator'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	main: {
		web_welcome_for_search_fasting_schedule,
		web_welcome_for_search_fasting_lose_weight,
		web_welcome_for_search_fasting_diet_keywords,
		web_welcome_for_search_fasting_calculator,
	},
	female: {
		web_autotest_female_funnel_check,
		web_fallback_on_payment,
		web_upsell_double_offering,
		web_ai_generated_female_funnel,
		web_en_countries_price_optimization,
		web_pricing_on_fasting_funnels_with_sp_nonus,
		web_fasting_fem_scratch_card_before_the_paywall,
		web_dynamic_email_capture,
		web_pricing_for_desktop,
		web_coins_in_exchange_for_discount,
		web_fasting_fem_paywall_w_plan_benefits,
	},
	male: {
		web_wheel_of_fortune_male,
		web_en_countries_price_optimization,
		web_ask_age_starting_screens,
		web_pricing_on_fasting_funnels_with_sp_nonus,
	},

	'main-activity': {},
	'activity-female-v2': {
		web_wheel_of_fortune_activity_female,
		web_ask_age_starting_screens,
	},
	'activity-male': {},
	'activity-female-pilates': {
		web_upsell_double_offering,
		web_en_countries_price_optimization,
		web_tiers_as_upgrade_pilates,
		web_pricing_on_pilates_funnel_with_sp,
		web_ask_age_starting_screens,
		web_pilates_gamification_progress,
	},

	'main-yoga': {
		web_yoga_printable_guide_welcome,
		web_chair_yoga_challenge_landing,
	},
	'activity-female-yoga': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_yoga_female,
		web_summary_checkpoints_yoga,
		web_pricing_for_desktop,
		web_yoga_female_scratch_card_before_the_paywall,
		web_fallback_on_payment,
	},
	'activity-female-yoga-al': {},

	'main-walking': {
		web_walking_to_lose_weight_gdn,
		web_walking_to_lose_weight_keyword,
	},
	'activity-female-walking': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_walking_female,
		web_summary_checkpoints_walking,
		web_upsell_double_offering,
		web_en_countries_price_optimization,
		web_walking_female_weight_loss_plan,
		web_ask_age_starting_screens,
		web_walking_female_indoor,
		web_bulk_change_walking_female,
		web_welcome_for_demgen_walking,
		web_all_payment_options_at_once,
		web_walking_loader_with_women,
		web_fallback_on_payment,
	},

	'activity-female-walking-al': {},

	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	'female-printable-walking': {},

	'main-tai-chi-walking': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {
		web_apple_pay_renaming,
		web_thai_chi_walking_fem_christmas_sale,
		web_tai_chi_walking_female_plan_benefits,
		web_fallback_on_payment,
	},
	'activity-female-tai-chi-walking-al': {},
	'activity-female-tai-chi-walking-pr': {},

	'activity-male-tai-chi-walking': {},

	'activity-male-walking': {
		web_ask_age_starting_screens,
		web_walking_male_one_predict_instead_of_two,
	},

	'main-tai-chi': {},
	'activity-female-tai-chi': {},

	'activity-male-tai-chi-yoga': {},

	'activity-male-chair-workouts': {
		web_chair_workouts_male_scratch_card,
		web_pricing_for_desktop,
		web_chair_workouts_male_subtitles,
	},

	'female-cortisol-diet': {},
	'female-mediterranean-diet': {},

	'female-menopause-diet': {},
	'female-glp': {},
	'female-al': {},
}

export default experimentsConfig
